import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { ILatestSocialAccountStatus } from "../../features/Configurations/Integration/interface";

export const useLatestSocialAccountStatus = (refetchInterval?: number | false ) => {
    return useQuery({
        queryKey: ["latest-social-account-status"],
        queryFn: async () => {
            const response = await httpService.get<ILatestSocialAccountStatus>(
                API_CONFIG.path.latestSocialAccountStatus
            );
            return response;
        },
        refetchInterval
    });
};
